// eslint-disable-next-line import/prefer-default-export
export const RelationshipValue = Object.freeze({
  POLICY_HOLDER: 'Policy Holder',
  SPOUSE: 'Spouse',
  DEFACTO: 'Defacto',
  EX_SPOUSE: 'Ex Spouse',
  OTHER: 'Other (Adult) Dependant',
  DAUGHTER: 'Daughter',
  SON: 'Son',
  FOSTER_CHILD: 'Foster Child',
  GRAND_CHILD: 'Grand Child',
  BABY: 'Baby',
  STEP_SON: 'Step Son',
  STEP_DAUGHTER: 'Step Daughter',
});
